module.exports = __webpack_public_path__ + "assets/ddf82036930a8dbd633f4bf2af35f05d.mp3";